import { PropsWithChildren } from 'react';
import { ColorSchemeScript, MantineProvider, useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import { cssVariablesResolver, themeConfig } from './theme.config';
import '@mantine/core/styles.css';
import '@mantine/spotlight/styles.css';
import '@mantine/dropzone/styles.css';

interface ThemeProviderProps extends PropsWithChildren {
  defaultColorScheme?: 'light' | 'dark' | 'auto';
}

export function ThemeProvider({
                                children,
                                defaultColorScheme = 'auto'
                              }: ThemeProviderProps) {
  return (
    <>
      <ColorSchemeScript defaultColorScheme={defaultColorScheme}/>
      <MantineProvider
        theme={themeConfig}
        defaultColorScheme={defaultColorScheme}
        cssVariablesResolver={cssVariablesResolver}
      >
        {children}
      </MantineProvider>
    </>
  );
}

// Hook to use theme utilities
export function useTheme() {
  const {colorScheme, setColorScheme, toggleColorScheme} = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme('light'); // Always 'light' or 'dark'

  const isDark = computedColorScheme === 'dark';

  // Correct toggle implementation using computed color scheme
  const toggleTheme = () => {
    setColorScheme(computedColorScheme === 'dark' ? 'light' : 'dark');
  };

  return {
    colorScheme, // User's selection: 'light' | 'dark' | 'auto'
    computedColorScheme, // Always 'light' or 'dark' (computed)
    isDark,
    setColorScheme,
    toggleTheme,
    toggleColorScheme, // Mantine's built-in toggle
  };
}